import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { actionSet } from './utils'
import { getPages } from 'component/pagination/utils'

import {
  FETCH_BEEPING_REPORT_SUCCESS,
  FETCH_BEEPING_REPORT_ERROR,
} from 'actionTypes'

export const fetchBeepingReport = (token, params) => (dispatch) => {
  const pagination = {
    hasPagination: true,
    page: params.page,
    offset: params.limit,
    size: params.limit,
  }

  return new Api(token, dispatch)
    .post(API_URL.BEEPING_REPORT, {
      ...params,
      ...pagination,
    })
    .then(({ data: { resultList, pages } }) => {
      dispatch(getPages(pages))
      dispatch(actionSet(FETCH_BEEPING_REPORT_SUCCESS, resultList))
    })
    .catch((error) => {
      console.error(error)
      dispatch(actionSet(FETCH_BEEPING_REPORT_ERROR, error))
    })
}
